import Button from '@mui/material/Button';
import React, { useCallback, useEffect, useRef } from 'react';

interface AutoCompleteProps{
  addAutoCompletePlace: (place: google.maps.places.PlaceResult[] | null) => void;
  maps: any;
}

const AutoComplete: React.FC<AutoCompleteProps> = (props) => {  

  const { maps, addAutoCompletePlace } = props;
  const onPlaceSelected = (place: google.maps.places.PlaceResult[] | null) => {
    addAutoCompletePlace(place);
  }

  const input = useRef<null | HTMLInputElement>(null);
  const searchBox = useRef<null | google.maps.places.SearchBox>(null);

  const handleOnPlacesChanged = useCallback(() => {
    if (onPlaceSelected) {
      const place = searchBox?.current?.getPlaces();
      if(place) onPlaceSelected(place);
    }
  }, [onPlaceSelected, searchBox]);

  useEffect(() => {
    if (!searchBox.current && maps) {
      searchBox.current = new maps.places.SearchBox(input.current);
      searchBox.current?.addListener('places_changed', handleOnPlacesChanged);
    }

    return () => {
      if (maps) {
        searchBox.current = null;
        maps.event.clearInstanceListeners(searchBox);
      }
    };
  }, [maps, handleOnPlacesChanged]);

  const clearInput = (e:React.SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if(input.current) input.current.value = '';
    onPlaceSelected(null);
  }

  return (
    <div style={{display:'flex', flexDirection:'row', padding:'2px 2px 2px 5px', border: '1px #cccccc solid', alignItems: 'center', marginBottom: '10px', borderRadius: '5px' }}>
      <input ref={input} placeholder={'Search for location...'} type="text"  style={{width: "100%", height: '36px', color: '#555555', fontSize: '16px', border: 'none', outline: 'none'}} />
      <Button style={{margin: '5px', height: '30px', backgroundColor: '#3f51b5'}}  variant="contained" onClick={clearInput}>Clear</Button>
    </div>
  )

}

export default AutoComplete;